import { Request } from '../../../../httpClient/serverApi/requests/Request';
import { IResult } from '../../../../httpClient/serverApi/types/IResponse';
import { ISetOwnerParams } from '../../../../spacesPlatform/utils/actionParams';

export class SetCustomizedViewsOwnerRequest extends Request<ISetOwnerParams, IResult> {
  constructor(ids: string[], ownerId: string) {
    super('setCustomizedViewsOwner', {
      ids: ids,
      ownerId: ownerId
    });
  }
}